import React from 'react'
import classNames from 'classnames'

export const TaxNotice = (props) => {
  return <div
    data-toggle="modal"
    data-target="[data-name=tax-deductibility-notice]"
    dangerouslySetInnerHTML={{ __html: I18n.t('shared.tax_deductibility_notice_html') }}
    className={classNames(props.additionalClassName)}>
  </div>
}
